export default __webpack_public_path__ + "static/media/2682810 - catcher direction flag weather wind windy.82062f0c.svg";